var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "task-group-stack" },
    _vm._l(_vm.groups, function(group) {
      return _c("section", { key: group.id, staticClass: "task-group" }, [
        _c("header", { staticClass: "task-group-header" }, [
          _c("span", {
            staticClass: "group-dot",
            style: { backgroundColor: group.color }
          }),
          _c("h2", [_vm._v(_vm._s(group.label))]),
          _c("span", { staticClass: "group-count" }, [
            _vm._v(_vm._s(group.rows.length))
          ])
        ]),
        _c(
          "div",
          {
            staticClass: "task-table-shell",
            style: { borderLeftColor: group.color }
          },
          [
            _c("div", { staticClass: "task-table-scroll" }, [
              _c("table", [
                _c("thead", [
                  _c("tr", [
                    _c("th", [_vm._v(_vm._s(_vm.$t("projects.deliverable")))]),
                    _c("th", { staticClass: "assignee-column" }, [
                      _vm._v(_vm._s(_vm.$t("projects.assigned-to")))
                    ]),
                    _c("th", { staticClass: "date-column" }, [
                      _vm._v(_vm._s(_vm.$t("projects.due")))
                    ]),
                    _c("th", { staticClass: "progress-column" }, [
                      _vm._v(_vm._s(_vm.$t("projects.tasks")))
                    ]),
                    _c("th", { staticClass: "action-column" })
                  ])
                ]),
                _c(
                  "tbody",
                  _vm._l(group.rows, function(row) {
                    return _c(
                      "tr",
                      {
                        key: row.deliverable.id,
                        class: { "is-subtask": row.isSubtask },
                        attrs: { tabindex: "0" },
                        on: {
                          click: function($event) {
                            return _vm.$emit(
                              "open-deliverable",
                              row.deliverable
                            )
                          },
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.$emit(
                              "open-deliverable",
                              row.deliverable
                            )
                          }
                        }
                      },
                      [
                        _c("td", [
                          _c(
                            "div",
                            {
                              staticClass: "task-name",
                              class: { indented: row.isSubtask }
                            },
                            [
                              _c("portal-icon", {
                                attrs: {
                                  name: row.isSubtask
                                    ? "arrow-right"
                                    : "clipboard-list",
                                  size: 15
                                }
                              }),
                              _c("strong", [
                                _vm._v(_vm._s(row.deliverable.name))
                              ])
                            ],
                            1
                          )
                        ]),
                        _c("td", [
                          row.deliverable.assignedToList &&
                          row.deliverable.assignedToList.length
                            ? _c(
                                "div",
                                { staticClass: "assignees" },
                                _vm._l(row.deliverable.assignedToList, function(
                                  assignedTo,
                                  index
                                ) {
                                  return _c("assigned-user", {
                                    key: assignedTo,
                                    style: {
                                      zIndex:
                                        row.deliverable.assignedToList.length -
                                        index
                                    },
                                    attrs: {
                                      "assigned-to": assignedTo,
                                      "assignable-users": _vm.assignableUsers,
                                      "show-name": false
                                    }
                                  })
                                }),
                                1
                              )
                            : _c("span", { staticClass: "empty-value" }, [
                                _vm._v("—")
                              ])
                        ]),
                        _c("td", [
                          row.deliverable.dueDate
                            ? _c(
                                "span",
                                { staticClass: "due-date" },
                                [
                                  _c("portal-icon", {
                                    attrs: { name: "calendar-days", size: 14 }
                                  }),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.formatDate(row.deliverable.dueDate)
                                      ) +
                                      " "
                                  )
                                ],
                                1
                              )
                            : _c("span", { staticClass: "empty-value" }, [
                                _vm._v("—")
                              ])
                        ]),
                        _c("td", [
                          row.deliverable.tasks && row.deliverable.tasks.length
                            ? _c(
                                "span",
                                { staticClass: "checklist" },
                                [
                                  _c("portal-icon", {
                                    attrs: { name: "list-checks", size: 14 }
                                  }),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.completedTasks(row.deliverable)
                                      ) +
                                      "/" +
                                      _vm._s(row.deliverable.tasks.length) +
                                      " "
                                  )
                                ],
                                1
                              )
                            : _c("span", { staticClass: "empty-value" }, [
                                _vm._v("—")
                              ])
                        ]),
                        _c(
                          "td",
                          { staticClass: "action-column" },
                          [
                            _c("portal-icon", {
                              attrs: { name: "chevron-right", size: 17 }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  }),
                  0
                )
              ])
            ])
          ]
        )
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }